import React from 'react';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Link } from 'react-router-dom';
import { Tag } from '../../Tags';
export var StorefrontTag = function StorefrontTag(_ref) {
  var tag = _ref.tag;
  return React.createElement(AppLink, {
    as: Link,
    to: "/invertir/".concat(tag.alias),
    title: tag.name
  }, React.createElement(Tag, null, tag.name));
};